import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../redux";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../components/loader/loader";
import logo from "../assets/logo.png";
import loginImg from "../assets/login_img.png";
import { FiArrowLeft, FiMail } from "react-icons/fi";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter your email");
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(`${baseUrl}/forgot-password`, { email });
      if (response.data.message) {
        toast.success(response.data.message);
        localStorage.setItem("resetEmail", email);
        navigate("/reset-password");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen w-full flex flex-col items-center justify-center relative px-4"
      style={{
        backgroundImage: `url(${loginImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Toaster position="top-right" />
      <Loader loading={loading} />

      {/* Full-page overlay */}
      <div className="absolute inset-0 bg-[#3d184e]/70" />

      {/* Back to login — top left */}
      <div className="absolute top-5 left-6 z-10">
        <Link
          to="/login"
          className="flex items-center gap-1.5 text-white/80 hover:text-white text-sm bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-full transition-colors"
        >
          <FiArrowLeft />
          Back to Login
        </Link>
      </div>

      {/* Card */}
      <div className="relative z-10 w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden">
        {/* Card header */}
        <div className="bg-[#3d184e] px-8 py-6 flex flex-col items-center">
          <img src={logo} alt="Logo" className="h-10 w-auto mb-3" />
          <h1 className="text-white font-bold text-xl">Forgot Password</h1>
          <p className="text-gray-400 text-xs mt-1 text-center">
            Enter your email and we'll send a reset code
          </p>
        </div>

        {/* Card body */}
        <div className="px-8 py-8">
          <div className="flex items-center justify-center mb-6">
            <div className="bg-teal-100 p-4 rounded-full">
              <FiMail className="text-teal-600 text-2xl" />
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">
                Email address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="you@example.com"
                className="w-full border-2 border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-teal-500 transition-colors"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-teal-600 hover:bg-teal-700 disabled:opacity-60 text-white font-semibold py-3 rounded-xl text-sm transition-colors"
            >
              {loading ? "Sending..." : "Send Reset Code"}
            </button>
          </form>

          <p className="text-center text-gray-400 text-xs mt-6">
            Remember your password?{" "}
            <Link to="/login" className="text-teal-600 font-medium hover:underline">
              Sign in
            </Link>
          </p>
        </div>
      </div>

      <p className="relative z-10 text-white/40 text-xs mt-6">
        © {new Date().getFullYear()} Revenue Pro Planner. All rights reserved.
      </p>
    </div>
  );
};

export default ForgotPassword;
